import keycloak from "Keycloak";
import { NUMBERS, SMALL_ALPHAS } from "./pageEditor/CommonConstants";
import { ADMINUI_ADMIN_ROLE, ADMINUI_PAYMENTS_ADD_CHARGE_ROLE, ADMINUI_PAYMENTS_APPLY_DISCOUNT_ROLE, ADMINUI_PAYMENTS_GENERATE_LINK_ROLE, ADMINUI_PAYMENTS_SYNC_PAYMENT_ROLE, ADMINUI_ROLE, ADMINUI_ROLE_MOVEAPPS, ADMINUI_ROLE_MULTIPLE_DEPLOY, ADMINUI_SUBSCRIPTION_CUSTOM_INVOICE_ROLE, ADMINUI_SUBSCRIPTION_DOWNLOAD_INVOICE_ROLE, ADMINUI_SUBSCRIPTION_VIEW_TIMELINE_ROLE, ADMINUI_USER_CREATE_ROLE, ADMINUI_USER_DELETE_ROLE, PAYMENT_LINK_CREATOR, SALES_ROLE ,ADMINUI_DOMAIN_WRITE_MANAGEMENT_ROLE ,ADMINUI_DOMAIN_READ_MANAGEMENT_ROLE} from "./constants";

export const downloadTxtFile = async (data, title) => {
  const element = document.createElement('a');
  const file = new Blob([data], {
    type: 'text/plain',
  });
  element.href = URL.createObjectURL(file);
  element.download = title + '.txt';
  document.body.appendChild(element);
  element.click();
};

export const debounceMethod = function (fn, delayTime = 500) {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.apply(context, args);
    }, delayTime);
  };
};

export const convertObjToArray = data => {
  return Object.entries(data).reduce((acc, [group, templates]) => {
      templates.forEach(template => {
          acc.push({ groupName: group, ...template });
      });
      return acc;
  }, []);
};
export  const convertObjIntoToArray = data => {
  return Object.entries(data).map(([groupName, templates]) => ({
    groupName,
    templates
  }));
};
// export const convertObjToArray = data => {
//   const groupNameSet = new Set();
//   return Object.entries(data).reduce((acc, [group, templates]) => {
//     templates.forEach(template => {
//       if (!groupNameSet.has(group)) {
//         acc.push({ groupName: group, ...template });
//         groupNameSet.add(group);
//       } else {
//         acc.push({...template });
//       }
//     });
//     return acc;
//   }, []);
// };

export const verifyUniqueCode = (uniqueCode, widgetUniqueCodeForPage, pageEditorModelDataPageList) => {
  let unique = false;
  let newUniqueCode = uniqueCode;

  const reducerWidgetFn = (pageWidgetNameList, currentPageWidgetDtls) => {
    pageWidgetNameList?.push(currentPageWidgetDtls?.widgetName);
    return pageWidgetNameList;
  };

  const reducerFn = (allPageWidgetNameList, currentPageDtls) => {
    allPageWidgetNameList?.push(
      currentPageDtls?.pageWidgetDtlsList &&
        currentPageDtls?.pageWidgetDtlsList?.reduce(reducerWidgetFn, []),
    );
    return allPageWidgetNameList;
  };

  const allPageWidgetList =
    pageEditorModelDataPageList && pageEditorModelDataPageList?.reduce(reducerFn, [])?.flat(1);
  
    do {
    unique = allPageWidgetList?.includes(newUniqueCode) ? false : true;
    if (!unique) {
      const randomFourDigitId = generate4DigitAlphanumeric();
      newUniqueCode = `${widgetUniqueCodeForPage}_${randomFourDigitId}`;
    }
  } while (!unique);

  return newUniqueCode;
};

export const generate4DigitAlphanumeric = () => {
  
  let result = "";

  for (let i = 0; i < 2; i++) {
    result += SMALL_ALPHAS.charAt(Math.floor(Math.random() * SMALL_ALPHAS.length));
  }

  for (let i = 0; i < 2; i++) {
    result += NUMBERS.charAt(Math.floor(Math.random() * NUMBERS.length));
  }

  result = result.split("").sort(() => 0.5 - Math.random()).join("");
  
  return result;
}

export const hasSalesRole = () => {
  return keycloak.hasRealmRole(SALES_ROLE);
};

export const hasPaymentCreatorRole = ()=>{
  return keycloak.hasRealmRole(PAYMENT_LINK_CREATOR);
}
export const hasAdminUiRole = () => {
  return keycloak.hasRealmRole(ADMINUI_ROLE);
};

export const hasAdminUserCreateRole = () => {
  return keycloak.hasRealmRole(ADMINUI_USER_CREATE_ROLE);
}

export const hasAdminUserDeleteRole = () => {
  return keycloak.hasRealmRole(ADMINUI_USER_DELETE_ROLE);
}

export const hasAdminRoleMoveApps = () => {
  return keycloak.hasRealmRole(ADMINUI_ROLE_MOVEAPPS);
}

export const hasAdminRoleMultipleDeployment = () => {
  return keycloak.hasRealmRole(ADMINUI_ROLE_MULTIPLE_DEPLOY);
}

export const hasAdminUiPaymentLinkGenerationRole = () => {
  return keycloak.hasRealmRole(ADMINUI_PAYMENTS_GENERATE_LINK_ROLE);
}

export const hasAdminUiDomainReadManagementRole = () => {
  return keycloak.hasRealmRole(ADMINUI_DOMAIN_READ_MANAGEMENT_ROLE);
}

export const hasAdminUiDomainWriteManagementRole = () => {
  return keycloak.hasRealmRole(ADMINUI_DOMAIN_WRITE_MANAGEMENT_ROLE);
}

export const hasAdminUiApplyDiscountRole = () => {
  return keycloak.hasRealmRole(ADMINUI_PAYMENTS_APPLY_DISCOUNT_ROLE);
}

export const hasAdminUiAddChargeRole = () => {
  return keycloak.hasRealmRole(ADMINUI_PAYMENTS_ADD_CHARGE_ROLE);
}

export const hasAdminUiSyncPaymentRole = () => {
  return keycloak.hasRealmRole(ADMINUI_PAYMENTS_SYNC_PAYMENT_ROLE);
}

export const hasAdminUiDownloadInvoiceRole = () => {
  return keycloak.hasRealmRole(ADMINUI_SUBSCRIPTION_DOWNLOAD_INVOICE_ROLE);
}

export const hasAdminUiCustomInvoiceRole = () => {
  return keycloak.hasRealmRole(ADMINUI_SUBSCRIPTION_CUSTOM_INVOICE_ROLE);
}

export const hasAdminUiViewTimelineRole = () => {
  return keycloak.hasRealmRole(ADMINUI_SUBSCRIPTION_VIEW_TIMELINE_ROLE);
}

export const hasAdminUiAdminRole = () => {
  return keycloak.hasRealmRole(ADMINUI_ADMIN_ROLE);
}